export default {
  title: 'Diesen Schritt übernimmt dein Anbieter',
  description: {
    payments: 'Wende dich an {{partner}}, um Online-Zahlungen einzurichten.',
    go_live: 'Wende dich an {{partner}}, um dein Restaurant live zu schalten.',
  },
  fallback_partner: 'deinen Anbieter',
};
